import axiosInstance from './axios';
import { API_URL } from '../config/api';

export const expenseService = {
  getExpenses: () => axiosInstance.get(`/api/expenses`),
  createExpense: (data) => axiosInstance.post(`/api/expenses`, data),
  updateExpense: (id, data) => axiosInstance.put(`/api/expenses/${id}`, data),
  deleteExpense: (id) => axiosInstance.delete(`/api/expenses/${id}`)
};
